import cn from "classnames";
import { Datetime } from "components/shared/form";
import React, { useEffect, useState } from "react";
import { applyOrganizationStartedDate, getOrganizationStartedDate } from "sources/organizationActivity";

const Settings = (props) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({});

    useEffect(() => {
        getOrganizationStartedDate().then((data) => {
            setData(data);
            setLoading(false);
        });
    }, []);

    const saveData = (e) => {
        e.preventDefault();
        setLoading(true);
        applyOrganizationStartedDate(data).then((res) => {
            setLoading(false);
            if (res) {
                props.back();
            }
        });
    };

    const renderDateField = (name, rest = {}) => {
        const value = data[name];
        const { inputProps, ...fieldProps } = rest;
        const onFieldChange = ({ value }) => setData({ ...data, [name]: value });
        return <Datetime inputProps={{ name, ...inputProps }} value={value} onChange={onFieldChange} {...fieldProps} />;
    };

    return (
        <form className={cn({ loading })} onSubmit={saveData}>
            <h5 className="pb-3">Настройки дашборда</h5>
            {renderDateField("startedAt", {
                label: "Стартовый месяц",
                fieldWrapper: "react-datepicker--reset",
                inputProps: { type: "custom" },
                format: { dateFormat: "LLLL, yyyy", showMonthYearPicker: true, minDate: new Date(2018, 0, 1) },
                inPortal: true,
            })}
            <button className="btn btn-sm btn-brand float-right" type="submit">
                Сохранить
            </button>
        </form>
    );
};

export default Settings;
